<template>
  <a-modal
    title="请选择需要暂停的小组和讲次"
    centered
    :width="1100"
    :visible="visible"
    :mask-closable="false"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-table
      row-key="id"
      :scroll="scroll"
      :loading="loading"
      :columns="columns"
      :data-source="tableData"
      :pagination="false"
    >
      <!-- eslint-disable-next-line vue/no-unused-vars -->
      <template slot="palyState" slot-scope="text, record">
        <span class="spot" :style="{background: text === 1 ? '#FF5C5C' : '#06C270'}" />
        <span :class="[text === 1 ? 'pause' : 'play']">
          <!-- 0：继续,1：暂停 -->
          {{ text === 1 ? '已暂停' : '学习中' }}
        </span>
      </template>

      <div slot="action" slot-scope="text, record">
        <a-button type="link" v-if="record.palyState === 0" @click="pause(record)">
          暂停
        </a-button>
        <a-button v-else type="link" @click="play(record)">
          继续学习
        </a-button>
      </div>
    </a-table>
  </a-modal>
</template>

<script>
import supervisionLogger from '@/utils/logger/supervision.js'

// 小组列表
const columns = [
  {
    dataIndex: 'xkhTeacherCourseName',
    key: 'xkhTeacherCourseName',
    title: '小组名称',
    ellipsis: true,
    align: 'left',
    scopedSlots: { customRender: 'xkhTeacherCourseName' }
  },
  {
    dataIndex: 'lessonName',
    key: 'lessonName',
    ellipsis: true,
    align: 'left',
    title: '讲次信息',
    customRender: (text, row) => `第${row.lessonNum}讲  ${row.lessonName}`
  },
  {
    dataIndex: 'groupStudentNum',
    key: 'groupStudentNum',
    align: 'left',
    title: '小组人数',
    scopedSlots: { customRender: 'groupStudentNum' }
  },
  {
    dataIndex: 'palyState',
    key: 'palyState',
    align: 'left',
    title: '状态',
    scopedSlots: { customRender: 'palyState' }
  },
  {
    title: '操作',
    align: 'center',
    width: 180,
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    groupArr: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      modalConfirmLoading: false,
      currentRow: null, // 当前操作行
      scroll: {
        x: 760,
        y: 'calc(100vh - 254px - 145px)'
      },
      loading: false,
      tableData: [], // 我的小组列表
      columns
    }
  },

  watch: {
    visible: {
      handler(nV) {
        // eslint-disable-next-line no-empty
        if (nV) {
          this.initList()
        }
      },
      immediate: true
    }
  },

  methods: {
    initList() {
      const arr = this.groupArr.map(k => {
        const xkhTeacherCourseId = String(k.id).includes('_') ? k.id.split('_')[0] - 0 : k.id // 小组id
        const lessonId = String(k.id).includes('_') ? k.id.split('_')[1].split('*')[0] - 0 : null// 讲次id
        if (lessonId) {
          return { xkhTeacherCourseId, lessonId }
        }
        return { xkhTeacherCourseId }
      })

      this.loading = true
      this.$service.supervision.lessonList({ groupIdToLessonIdMap: arr }).then(res => {
        this.loading = false
        this.tableData = res || []
      }).catch(err => {
        this.loading = false
      })
    },

    play(row) {
      this.currentRow = row
      this.$confirm({
        content: () => <div>确认继续学习该讲次吗？</div>,
        confirmLoading: this.modalConfirmLoading,
        centered: true,
        // 展示不下时，需要加滚动条
        onOk: () => this.handlePlay(),
        cancelText: '取消'
      })
    },

    handlePlay() {
      const _this = this
      this.modalConfirmLoading = true
      const { id } = this.currentRow
      return new Promise((resolve, reject) => {
        this.$service.supervision.setPlaystate({
          id, // 小组讲次主键Id
          status: 0 // 0继续，1暂停
        }).then(res => {
          _this.modalConfirmLoading = false
          this.initList() // 列表更新
          resolve()
        }).catch(err => {
          _this.modalConfirmLoading = false
          // eslint-disable-next-line prefer-promise-reject-errors
          reject()
        }).finally(() => {
          _this.modalConfirmLoading = false
        })
      })
    },

    handlerPause() {
      const _this = this
      this.modalConfirmLoading = true
      const { id } = this.currentRow
      return new Promise((resolve, reject) => {
        this.$service.supervision.setPlaystate({
          id, // 小组讲次主键Id
          status: 1 // 0继续，1暂停
        }).then(res => {
          _this.modalConfirmLoading = false
          const { xkhTeacherCourseId, lessonId, aiLessonId } = this.currentRow
          supervisionLogger.pauseLogger({
            groupId: xkhTeacherCourseId,
            lessonId,
            aiLessonId
          })
          this.initList() // 列表更新
          resolve()
        }).catch(err => {
          _this.modalConfirmLoading = false
          // eslint-disable-next-line prefer-promise-reject-errors
          reject()
        }).finally(() => {
          _this.modalConfirmLoading = false
        })
      })
    },

    pause(row) {
      this.currentRow = row
      this.$confirm({
        content: () => <div>您确认暂停学习该讲次吗？</div>,
        confirmLoading: this.modalConfirmLoading,
        centered: true,
        // 展示不下时，需要加滚动条
        onOk: () => this.handlerPause(),
        cancelText: '取消'
      })
    },

    handleCancel() {
      this.$emit('update:visible', false)
    },
    onOK() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';
:deep(.ant-table-fixed-header .ant-table-scroll .ant-table-header) {
  overflow: overlay !important;
  padding-bottom: 15px !important;
}
.spot {
  display: inline-block;
  width: 4px;
  height: 4px;
  position: relative;
  top: -3px;
  border-radius: 1px;
  transform: rotate(45deg);
}
.play {
  color: #303858;
}
.pause {
  color: #FF5C5C;
}
</style>